import { trackData } from '@/mixins/trackingHandler'

function getTrackingStepName (stepName, mnpActive) {
  switch (stepName) {
    case 'mnpData':
      return (mnpActive ? 'mnp toggle on' : 'mnp toggle off')
    case 'customerData':
      return 'customer data'
    case 'simData':
      return 'sim data'
    case 'paymentData':
      return 'payment data'
    case 'identData':
      return 'ident data'
    case 'cart':
      return 'summary'
    case 'success':
      return 'confirmation'
    default:
      return stepName
  }
}
function getTrackingProcess (process) {
  switch (process) {
    case 'ordering':
      return 'checkout'
    case 'activation':
      return 'sim activation'
    case 'belatedPorting':
      return 'belated number porting'
    default:
      return process
  }
}
function getTrackingIdentMethod (method) {
  switch (method) {
    case 'video':
      return 'video call'
    case 'store':
      return 'post office'
    default:
      return method
  }
}

const checkoutTracking = (process, store, stepName, stepNumber = null) => {
  // mnp
  const mnpActive = store.getters['checkoutv2/' + process + '/_mnpData/active']
  const mnpProvider = store.getters['checkoutv2/' + process + '/_mnpData/provider']
  const mnpPortingData = store.getters['checkoutv2/' + process + '/_mnpData/portingData']
  const mnpData = { active: mnpActive, provider: mnpProvider, contract: { end: mnpPortingData.dateType } }

  // cart
  let targetTariff = store.getters['checkoutv2/' + process + '/_cart/targetTariff']
  const kwkToken = store.getters['checkoutv2/' + process + '/_cart/kwkToken']
  const kwkPromotions = store.getters['checkoutv2/' + process + '/_cart/kwkPromotions']
  const defaultTariff = {
    name: 'SIMon mobile flex',
    type: 'tariff',
    duration: 1,
    units: 1,
    price_once: 0,
    tariffId: kwkToken ? '162' : '155',
    basicFee: kwkToken ? 899 : 1199
  }
  targetTariff = (mnpActive && !mnpProvider.brandName) ? defaultTariff : targetTariff // if mnp true but no provider is selected, track only default tariff
  const targetTariffoptions = store.getters['checkoutv2/' + process + '/_cart/targetTariffoptions']
  const selectedAboOption = targetTariffoptions?.length > 0 ? targetTariffoptions[0] : null
  const selectedStarterKit = { singlePaymentFee: 0 }
  const voucherPromos = store.getters['checkoutv2/' + process + '/_cart/voucherPromotions'] // used in propositions
  const voucherCode = store.getters['checkoutv2/' + process + '/_cart/voucherCode']
  let voucherItem = { // used in voucher tracking below
    id: '',
    name: '',
    type: '',
    promoCode: ''
  }
  if (voucherCode) {
    voucherPromos.forEach(promo => {
      voucherItem.id += promo.promotionId + '|'
      voucherItem.name += promo.name + '|'
      voucherItem.type = promo.incentives[0]?.type // funktioniert nur bei gleichem Type
    })
    voucherItem.promoCode = voucherCode + '|'
  }
  if (kwkToken) {
    kwkPromotions.forEach(promo => {
      voucherItem.id += promo.promotionId + '|'
      voucherItem.name += promo.name + '|'
    })
    voucherItem.promoCode += 'kwkToken' + '|'
  }
  voucherItem.id = voucherItem.id.slice(0, -1)
  voucherItem.name = voucherItem.name.slice(0, -1)
  voucherItem.promoCode = voucherItem.promoCode.slice(0, -1)
  if (!voucherItem.id) {
    voucherItem = null
  }

  // sim
  const simType = store.getters['checkoutv2/' + process + '/_simData/simData'].simType

  // ident
  const identType = store.getters['checkoutv2/' + process + '/_identData/identData'] ? getTrackingIdentMethod(store.getters['checkoutv2/' + process + '/_identData/identData'].identType) : null

  // payment
  const paymentFilled = store.getters['checkoutv2/' + process + '/_paymentData/bankAccount']?.confirmation

  // initiate response
  const consent = store.getters['checkoutv2/' + process + '/consents']
  const contractId = store.getters['checkoutv2/' + process + '/confirmResult']?.contractId

  // renaming for tracking
  stepName = getTrackingStepName(stepName, mnpActive)
  process = getTrackingProcess(process)
  // proposition items
  let propositions = ''
  if (typeof window.trackingNS?.track?.getPropositions === 'function') {
    propositions = window.trackingNS.track.getPropositions(mnpData, targetTariff, selectedStarterKit, defaultTariff, voucherItem, selectedAboOption, simType, voucherPromos)
  }

  // data
  let portingTime = 'no mnp'
  if (mnpActive) {
    if (typeof window.trackingNS?.track?.getPortingTime === 'function') {
      portingTime = window.trackingNS.track.getPortingTime(mnpData)
    }
  }

  const data = {
    page_levels: process === 'belated number porting' ? [
      'mein-simon',
      'service',
      process,
      stepName
    ] : [
      'mobility',
      process,
      stepName
    ],
    page_type: process === 'belated number porting' ? 'self service' : 'checkout',
    login_status: process === 'belated number porting' ? 'logged in' : 'not logged in',
    platform_type: 'browser view',
    form: {
      name: process,
      step: stepNumber,
      step_name: stepName,
      type: process === 'belated number porting' ? 'ecare' : 'order funnel'
    },
    propositions: propositions,
    porting_time: portingTime
  }

  // track data depending on store
  if (identType) {
    data.identification_method = identType
  }
  if (paymentFilled) {
    data.payment_method_once = 'lastschrift'
    data.payment_method_recurring = 'lastschrift'
  }
  if (contractId) {
    data.order_id = contractId
  }

  // summary
  if (stepName === 'summary' && process !== 'belated number porting') {
    data.bew_shown = {
      version: 'v1',
      contact: 'asked',
      data: 'asked'
    }
  }

  // success pages
  if (stepName === 'confirmation') {
    if (process !== 'belated number porting') {
      data.bew_selected = {
        version: 'v1',
        contact: consent?.contact ? 'yes' : 'no',
        data: consent?.exchange ? 'yes' : 'no'
      }
    }
    data.form.status = 'success'
    if (identType) {
      data.form.step_name = 'confirmation with ident'
    }
    if (voucherItem) {
      data.voucher_action = 'redeem'
      data.voucher_name = voucherItem.name
      data.voucher_code = voucherItem.promoCode
    }
  } else if (voucherItem) { // all pages except for success
    data.voucher_action = 'display'
    data.voucher_name = voucherItem.name
    data.voucher_code = voucherItem.promoCode
  }

  trackData('pageview', data)
}

const substituteSimTracking = (store, stepNumber = null) => {
  const selectedSim = store.getters['checkoutv2/substituteSim/selectedSim']
  const activated = store.getters['checkoutv2/substituteSim/activated']
  const stepName = stepNumber === 1 ? 'sim type selection' : stepNumber === 2 ? 'summary' : 'confirmation'
  const data = {
    activation_method: activated ? 'preactivated' : 'by_customer',
    page_levels: [
      'mein-simon',
      'meine-sim',
      'sim replacement',
      stepName
    ],
    page_type: 'checkout',
    login_status: 'logged in',
    platform_type: 'browser view',
    form: {
      name: 'sim replacement',
      step: '' + stepNumber,
      step_name: stepName,
      type: 'order funnel'
    },
    propositions: [{
      name: 'replacement sim',
      audience: 'consumer',
      type: 'credit',
      line: 'voice',
      category: 'service',
      items: []
    }]
  }
  if (stepNumber > 1) {
    data.propositions[0].items = [
      {
        id: selectedSim.productNumber,
        name: 'replacement sim',
        type: 'service',
        price_once: selectedSim.productPrice,
        units: 1
      },
      {
        id: 'simType',
        name: selectedSim.type === 'SIM_CARD' ? 'sim_card' : 'e_sim',
        type: 'service',
        units: 1
      }
    ]
    if (selectedSim.type === 'SIM_CARD') {
      data.shipping_price = selectedSim.shippingCosts
    }
  }
  if (stepNumber === 3) {
    data.form.status = 'success'
  }
  trackData('pageview', data)
}
export { checkoutTracking, substituteSimTracking }
